import React, { useRef, useState } from 'react';
import { View, StyleSheet, ActivityIndicator, Platform, Text, TouchableOpacity } from 'react-native';
import { WebView } from 'react-native-webview';
import { Color, FontFamily, FontSize } from '@common';
import { useNavigation } from '@react-navigation/native';

const PaymentWebView = ({ route }) => {
  const { paymentUrl, refNo } = route.params;
  const navigation = useNavigation();
  const webViewRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  const handleNavigationStateChange = (navState) => {
    // Check if payment is complete by monitoring URL changes
    const url = navState.url;

    // If the URL contains verify or success/failed pages, navigate to Verify screen
    if (url.includes('/verify') || url.includes('payment-status')) {
      navigation.replace('Verify', { refNo });
    }
  };

  const handleBackPress = () => {
    navigation.goBack();
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={handleBackPress} style={styles.backButton}>
          <Text style={styles.backText}>← Back</Text>
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Payment</Text>
        <View style={styles.placeholder} />
      </View>

      <WebView
        ref={webViewRef}
        source={{ uri: paymentUrl }}
        style={styles.webview}
        onNavigationStateChange={handleNavigationStateChange}
        onLoadStart={() => setIsLoading(true)}
        onLoadEnd={() => setIsLoading(false)}
        javaScriptEnabled={true}
        domStorageEnabled={true}
        startInLoadingState={true}
        scalesPageToFit={true}
        allowsBackForwardNavigationGestures={true}
        renderLoading={() => (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="large" color={Color.steelblue_200} />
          </View>
        )}
      />

      {isLoading && (
        <View style={styles.loadingOverlay}>
          <ActivityIndicator size="large" color={Color.steelblue_200} />
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.white,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 12,
    paddingTop: Platform.OS === 'ios' ? 50 : 12,
    backgroundColor: Color.steelblue_100,
    borderBottomWidth: 1,
    borderBottomColor: Color.gray_100,
  },
  backButton: {
    paddingVertical: 8,
    paddingHorizontal: 8,
    flex: 1,
  },
  backText: {
    fontSize: FontSize.size_base,
    color: Color.white,
    fontFamily: FontFamily.interMedium,
  },
  headerTitle: {
    fontSize: FontSize.size_lg,
    fontFamily: FontFamily.interBold,
    color: Color.white,
    flex: 2,
    textAlign: 'center',
  },
  placeholder: {
    flex: 1,
  },
  webview: {
    flex: 1,
  },
  loadingContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Color.white,
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
  },
});

export default PaymentWebView;
